module.exports = __webpack_public_path__ + "static/img/activity2.a059f8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/newsImg/activity2.jpg
// module id = A0sg
// module chunks = 0